import type { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    channelPageChannelNavigated,
    ChannelPageChannelNavigatedTo,
    channelPageChannelShowed,
    channelPageNavigatedV2,
    ChannelPageNavigatedV2To,
    channelPageShowed,
} from '@kinopoisk-int/evgen-web-events/web/channel_page';

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    cardShowed(contentId: string, channelName: string, programName: string) {
        eventSender.sendOnce(channelPageChannelShowed, {
            title: programName ?? '-',
            uuid: contentId ?? '-',
            channelName: channelName ?? '-',
        });
    },
    cardClicked(contentId: string, channelName: string, programName: string) {
        eventSender.send(channelPageChannelNavigated, {
            title: programName ?? '-',
            uuid: contentId ?? '-',
            channelName: channelName ?? '-',
            to: ChannelPageChannelNavigatedTo.PlayerScreen,
        });
    },
    channelNavigated() {
        eventSender.send(channelPageNavigatedV2, {
            to: ChannelPageNavigatedV2To.PlayerScreen,
        });
    },

    channelShowed() {
        eventSender.send(channelPageShowed, {});
    },

    navigatedToChannelList() {
        eventSender.send(channelPageNavigatedV2, {
            to: ChannelPageNavigatedV2To.ChannelListScreen,
        });
    },
});
